<div class="tp-trigger" [class.tp-disabled]="disabled" (click)="open()"> 
  <div class="tp-input-row">
    <svg class="tp-clock-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/>
      <path d="M12 7V12L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>

    <span class="tp-value" [class.tp-placeholder]="!displayValue">
      {{ displayValue || placeholder }}
    </span>

    <button
      *ngIf="hasValue && !disabled"
      class="tp-clear-btn"
      type="button"
      title="Clear"
      (click)="clear($event)">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
      </svg>
    </button>

    <svg *ngIf="!hasValue" class="tp-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none"
         [class.tp-open]="isOpen">
      <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </div>
</div>

<div class="tp-backdrop" *ngIf="isOpen" (click)="onBackdropClick($event)">
  <div class="tp-popup" (click)="$event.stopPropagation()">

    <div class="tp-header">
      <span class="tp-header-title">Select Time</span>
      <div class="tp-preview">
        {{ selectedHour }}:{{ selectedMinute }}
        <span class="tp-period-badge">{{ selectedPeriod }}</span>
      </div>
    </div>

    <div class="tp-drums-container">

      <div class="tp-drum-wrapper">
        <span class="tp-drum-label">HR</span>
        <div class="tp-drum" #hourDrum
             (scroll)="onDrumScroll($event, 'hour')"
             (touchstart)="onTouchStart($event, 'hour')"
             (touchmove)="onTouchMove($event, 'hour')"
             (touchend)="onTouchEnd($event, 'hour')">
          <div class="tp-item tp-pad"></div>
          <div class="tp-item tp-pad"></div>
          <div *ngFor="let h of hours; let i = index"
               class="tp-item"
               [class.tp-item-selected]="isSelected('hour', h)"
               (click)="selectItem('hour', i)">{{ h }}</div>
          <div class="tp-item tp-pad"></div>
          <div class="tp-item tp-pad"></div>
        </div>
      </div>

      <div class="tp-colon">:</div>

      <div class="tp-drum-wrapper">
        <span class="tp-drum-label">MIN</span>
        <div class="tp-drum" #minuteDrum
             (scroll)="onDrumScroll($event, 'minute')"
             (touchstart)="onTouchStart($event, 'minute')"
             (touchmove)="onTouchMove($event, 'minute')"
             (touchend)="onTouchEnd($event, 'minute')">
          <div class="tp-item tp-pad"></div>
          <div class="tp-item tp-pad"></div>
          <div *ngFor="let m of minutes; let i = index"
               class="tp-item"
               [class.tp-item-selected]="isSelected('minute', m)"
               (click)="selectItem('minute', i)">{{ m }}</div>
          <div class="tp-item tp-pad"></div>
          <div class="tp-item tp-pad"></div>
        </div>
      </div>

      <div class="tp-drum-wrapper tp-drum-wrapper--period">
        <span class="tp-drum-label">AM/PM</span>
        <div class="tp-drum tp-drum--period" #periodDrum
             (scroll)="onDrumScroll($event, 'period')"
             (touchstart)="onTouchStart($event, 'period')"
             (touchmove)="onTouchMove($event, 'period')"
             (touchend)="onTouchEnd($event, 'period')">
          <div class="tp-item tp-pad"></div>
          <div class="tp-item tp-pad"></div>
          <div *ngFor="let p of periods; let i = index"
               class="tp-item"
               [class.tp-item-selected]="isSelected('period', p)"
               (click)="selectItem('period', i)">{{ p }}</div>
          <div class="tp-item tp-pad"></div>
          <div class="tp-item tp-pad"></div>
        </div>
      </div>

      <div class="tp-selection-band"></div>
      <div class="tp-fade-top"></div>
      <div class="tp-fade-bottom"></div>
    </div>

    <div class="tp-actions">
      <button class="tp-btn tp-btn-cancel" (click)="cancel()">Cancel</button>
      <button class="tp-btn tp-btn-confirm" (click)="confirm()">Done</button>
    </div>

  </div>
</div>